/* Stylesheet */

.admin_dashboard_wrapper {
  height: 100%;
  width: 100%;

  .content_container {
    .children_container {
      height: 100%;
      padding: 32px;
    }
  }
}
